<template>
  <footer class="mt-4 pt-4">
    <v-layout row wrap justify-center>
      <v-layout px-4 pb-4 row wrap justify-space-between style="max-width: 1440px">
        <v-flex class="text-xs-center text-sm-left mt-3" v-if="company">
          <p v-if="company.paymentTypes"><strong>{{$lang.global.paymentMethods}}: </strong>
            <span v-for="(method, index) in company.paymentTypes" :key="index">
              {{$lang.global[method]}}{{index + 1 === company.paymentTypes.length ? '' : ', '}}
            </span>
          </p>
          <p v-if="company.orderTypes"><strong>{{$lang.global.deliveryMethods}}:</strong>
            <span v-for="(type, index) in company.orderTypes" :key="index">{{index === 0 ? ' ' : ', '}}{{$lang.actions[type]}}</span>
          </p>
          <p class="mt-3">{{$lang.global.sysVersion}}: {{company.systemVersion}}</p>
          <p>{{$lang.global.feVersion}}: {{feVersion}}</p>
          <p class="mb-3">{{$lang.global.resourceId}}: {{resource}}</p>
        </v-flex>
        <v-flex class="text-xs-center text-sm-left mt-3 pl-2"
                v-if="company && company.orderTypes && company.orderTypes.includes('delivery')">
          <p><strong>{{$lang.global.orderFees}}:</strong></p>
          <div v-html="deliveryCharges"></div>
        </v-flex>
        <v-flex class="text-xs-center text-sm-left mt-3 pl-2" v-if="workingHours">
          <p><strong>{{$lang.global.openingHours}}:</strong></p>
          <div v-html="workingHours"></div>
        </v-flex>
        <v-flex :class="{
          'quicklinks text-xs-center text-sm-left pl-2': true,
           'mt-3': !isLoggedIn
           }"
                v-if="companyActive !== false">
          <div v-if="!isLoggedIn">
          <p><strong>{{$lang.global.quickLinks}}:</strong></p>
          <router-link :to="{ name: 'login' }">{{$lang.header.login}}</router-link>
          <router-link :to="{ name: 'registration' }">{{$lang.header.register}}</router-link>
          <router-link :to="{ name: 'forgotPassword' }">{{$lang.global.forgotPassword}}</router-link>
          </div>
          <p class="pt-2 mt-1"><strong>{{$lang.global.language}}:</strong></p>
          <a @click="langChange('de')">{{$lang.global.german}}</a>
          <a @click="langChange('en')">{{$lang.global.english}}</a>
          <p class="pt-2 mt-1"><strong>{{$lang.global.theme}}:</strong></p>
          <p @click="changeTheme()">
            {{goDark ? $lang.global.light : $lang.global.dark}}
          </p>
        </v-flex>
      </v-layout>
    </v-layout>
    <div class="copyright">
      <v-layout row wrap justify-center fill-height align-center>
        <v-layout px-4 row wrap justify-space-between fill-height align-center style="max-width: 1440px">
          <v-flex sm6>
            <p class="mr-3 mb-0" v-if="formatedHtmlHints['webshop.footer.copyright-html']" v-html="formatedHtmlHints['webshop.footer.copyright-html']">
            </p>
            <p class="mr-3 mb-0" v-if="company && !formatedHtmlHints['webshop.footer.copyright-html']">
              {{ new Date().getFullYear() }} © {{ company.name }} {{$lang.global.allRights}}.
            </p>
          </v-flex>
          <v-flex text-sm-right sm6>
            <p class="mb-0">
              <a v-if="formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link']"
                 class="mr-3"
                 :href="`/${$route.params.lang}/${formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link']}`"
                 target="_blank">{{$lang.header.cookiePrivacy}}</a>
              <a v-else class="mr-3" :href="`/${$route.params.lang}/data-protection-policy`" target="_blank">{{$lang.header.cookiePrivacy}}</a>
              <a v-if="formatedHtmlHints['webshop.footer.termins-and-conditions-link']"
                 :href="`/${$route.params.lang}/${formatedHtmlHints['webshop.footer.termins-and-conditions-link']}`"
                 target="_blank">{{$lang.header.tearmsConditions}}</a>
              <a v-else :href="`/${$route.params.lang}/terms-and-Conditions`" target="_blank">{{$lang.header.tearmsConditions}}</a>
            </p>
          </v-flex>
        </v-layout>
      </v-layout>
    </div>
  </footer>
</template>

<script>
  import { mapGetters } from 'vuex';
  import auth from '../../auth';

  export default {
    data: () => ({
      isLoggedIn: null,
      paymentMethods: [],
      deliveryMethods: [],
      waitingTime: '',
      orange: true,
      blue: false,
      green: false,
      experiment: false,
      htmlHints: [],
      formatedHtmlHints: {},
      feVersion: 0,
    }),
    computed: {
      ...mapGetters({
        company: 'company',
        workingHours: 'workingHours',
        deliveryCharges: 'deliveryCharges',
        companyActive: 'companyActive',
        goDark: 'goDark',
      }),
      resource() {
        return localStorage.getItem('webShopResourceId');
      },
    },
    watch: {
      orange(val) {
        if (val === true) {
          this.blue = false;
          this.green = false;
          this.experiment = false;
          this.$vuetify.theme.primary = '#efa546';
          this.$vuetify.theme.secondary = '#efa546';
          this.$vuetify.theme.accent = '#efa546';
        }
      },
      blue(val) {
        if (val === true) {
          this.orange = false;
          this.green = false;
          this.experiment = false;
          this.$vuetify.theme.primary = '#007BFF';
          this.$vuetify.theme.secondary = '#007BFF';
          this.$vuetify.theme.accent = '#007BFF';
        }
      },
      green(val) {
        if (val === true) {
          this.blue = false;
          this.orange = false;
          this.experiment = false;
          this.$vuetify.theme.primary = '#43A047';
          this.$vuetify.theme.secondary = '#43A047';
          this.$vuetify.theme.accent = '#43A047';
        }
      },
      experiment(val) {
        if (val === true) {
          this.blue = false;
          this.orange = false;
          this.green = false;
          const elems = document.getElementsByClassName('theme--light');
          elems[0].style.backgroundColor = 'white';
          const vcard = document.getElementById('vCardId');
          vcard.style.backgroundColor = '#F5F5F5';
          // this.$vuetify.theme.primary = '#43A047';
          // this.$vuetify.theme.secondary = '#43A047';
          // this.$vuetify.theme.accent = '#43A047';
        }
      },
      company(val) {
        if (val) {
          // console.log(val);
          this.htmlHints = val.htmlHints;
          this.formatHtmlHints();
        }
      },
      '$route.path': {
        handler() {
          this.isLoggedIn = auth.isLoggedIn();
        },
      },
    },
    methods: {
      changeTheme() {
        localStorage.theme = this.goDark ? 'light' : 'dark';
        this.$store.dispatch('goDark', !this.goDark);
      },
      formatHtmlHints() {
        if (this.htmlHints && this.htmlHints.length > 0) {
          for (let i = 0; i < this.htmlHints.length; i += 1) {
            this.formatedHtmlHints[this.htmlHints[i].name] = this.htmlHints[i].value;
          }
        }
      },
      inNewTab(name) {
        const routeData = this.$router.resolve({ name });
        window.open(routeData.href, '_blank');
      },
      langChange(lang) {
        this.$lang.setLang(lang);
        localStorage.setItem('lang', lang);
        if (this.$route.params.lang !== lang) {
          this.$route.params.lang = lang;
          // eslint-disable-next-line max-len
          this.$router.push({ name: this.$route.name, query: this.$route.query, params: this.$route.params });
        }
        window.location.reload(true);
      },
    },
    created() {
      if (localStorage.staticHash) {
        this.feVersion = localStorage.staticHash;
      }
      if (this.company) {
        this.paymentMethods = this.company.paymentTypes;
      }
    },
  };
</script>

<style lang="scss" scoped>
  footer {
    color: #dadada;
    font-size: 12px;
    background-color: #585f69;

    p {
      margin-bottom: 5px;
    }
  }

  .quicklinks a {
    display: block;
    text-decoration: none;
  }

  .copyright {
    width: 100%;
    height: 67px;
    background-color: #3e4753;
    border-top: solid 1px #777;
  }

  .copyright a {
    text-decoration: none;
  }
</style>

<style lang="scss">
  .orange-theme,
  .blue-theme,
  .green-theme,
  .white-theme {
    cursor: pointer;
    max-width: 150px;
    max-height: 24px;
    background-color: transparent !important;

    label {
      font-size: 12px !important;
    }
  }

  .orange-theme {
    color: #efa546 !important;
  }

  .blue-theme {
    color: #007BFF !important;
  }

  .green-theme {
    color: #43A047 !important;
  }

  .white-theme {
    color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Footer.vue